import { getDocumentPageUrl } from './url-helpers';
import { openPopup } from './utils';
export function sharePublicationOnFacebook(config, publication, pageNumber) {
    shareLinkOnFacebook({
        url: getDocumentPageUrl({
            mainHost: config.hosts.main,
            documentName: publication.name,
            username: publication.username,
            pageNumber,
        }),
    });
}
export function shareLinkOnFacebook(link) {
    openPopup({ url: 'https://www.facebook.com/sharer.php', params: { u: link.url } });
}
//# sourceMappingURL=facebook.js.map